export default __webpack_public_path__ + "static/media/Carousel3.4e68a3bf.jpg";